import { render } from "./Item.vue?vue&type=template&id=416d60c6"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=416d60c6&lang=less"

import exportComponent from "C:\\Users\\rebec\\Desktop\\dev\\dma-question-edits\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__